import { toaster, Notification, Modal, Button } from "@appkit4/react-components";
import { CSSProperties, FC, ReactNode, useEffect, useMemo, useState } from "react";
import { useCookies } from "react-cookie";
import { useLocation } from "react-router-dom";
import Loader from "./loader";

function delay(time: number) {
  return new Promise(resolve => setTimeout(resolve, time));
}
export const scrollToAnchor = (hash: string) => {
  let hashElement = hash
    ? document.getElementById(hash)
    : null;
  if (hashElement !== null) {
    let position = hashElement.getBoundingClientRect().top - 56;
    window.scrollTo({
      top: position,
      behavior: "smooth"
    });
  }
}
export const toastMessage = async (data: string | ReactNode, hyperlink?: ReactNode, status?: "warning" | "error" | string, duration: number = 3000, position: string = "bottomRight") => {
  await delay(100);
  const item = (<Notification
    id={new Date().toString()}
    message={typeof data === "string" ? <div>{data}</div> : data}
    status={status
      ? status
      : "icon-circle-warning-outline"
    }
    hyperLink={hyperlink}
    closeable={duration === 0 ? true : false}
  />)
  toaster.notify(item, { position: position, duration: duration })
}


export const FormError: FC<{ error: string | null | undefined }> = ({ error }) => {
  return error
    ? (
      <div className="ap-error flex items-center p-4 gap-4 mt-6 mb-6">
        <div className="p-3">
          <span className="Appkit4-icon icon-error-fill ap-font-40"></span>
        </div>
        <div className="grow">
          <p className="ap-font-medium">Error</p>
          <p>{error}</p>
        </div>
      </div>)
    : null;
}


export const AnchorCatcher: FC = () => {
  let location = useLocation();
  let hashElement = useMemo(() => {
    let hash = location.hash.slice(1);
    return hash
      ? document.getElementById(hash)
      : null
  }, [location]);
  useEffect(() => {

    if (hashElement) {
      var headerOffset = 56;
      var elementPosition = hashElement.getBoundingClientRect().top;
      var offsetPosition = elementPosition + window.scrollY - headerOffset;
      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth"
      });
    }
  });
  return null;
}



export const LoaderWrapper: FC<{ loading: boolean[], errors: (Error | null)[], children: ReactNode, inline?: boolean }> = ({ loading, errors, children, inline = false }) => {
  const hasError = errors.some(e => e !== null);
  const stillLoading = loading.some(l => l === true);
  return (<>
    {stillLoading
      ? <Loader loadingType="circular" inline={inline} />
      : hasError
        ? <PageError />
        : children
    }
  </>)
}

export const PageError: FC<{ message?: string | null }> = ({ message }) => (
  <div className="text-center p-8">
    <span className="Appkit4-icon icon-error-fill ap-font-40"></span>
    <h3>{message || "Unable to fetch data"}</h3>
    <p>Something unexpected happened, please try again later or contact support.</p></div>
)


export const ValidationError: FC<{ error: string }> = ({ error }) => (
  <div id="errormessage" aria-live="polite" className="ap-field-email-validation-error">{error}</div>
)

export const CookieCheck: FC = () => {
  const [cookies, setCookie] = useCookies();
  const [approval, setApproval] = useState(cookies['_cookies'] || null)

  const acceptAll = () => {
    setCookie("_cookies", Date.now(), {
      maxAge: 60 * 60 * 25 * 180,
      secure: true,
      sameSite: "strict"
    });
    setApproval("close");
  }
  const rejectAll = () => {

  }
  return !approval
    ? (
      <div className="ap-cookie-bar">
        <div className="flex items-center gap-4 p-4">
          <div className="grow">
            <h3>Cookies: The choice is yours</h3>
            <p>
              We use cookies to make our site work well for you and so we can continually improve it.
              The cookies that keep the site functioning are always on.
              We use analytics cookies to help us understand what content is of most interest and to personalize your experience.
              <a href="/cookies" aria-label="More information the cookies used" >Cookie information</a>
            </p>
          </div>
          <div>
            <Button kind="negative" onClick={rejectAll}>Reject all cookies</Button>
          </div>
          <div>
            <Button kind="primary" onClick={acceptAll}>Accept all cookies</Button>
          </div>
        </div>
      </div>
    )
    : null
}



export interface ModalProps {
  visible: boolean,
  children: ReactNode,
  title?: string,
  cancel?: () => void,
  confirm?: () => void
  modalStyle?: CSSProperties
}

export const ConfirmationModal: FC<ModalProps> = ({ children, visible, title, cancel, confirm, modalStyle }) => {
  return (
    <Modal
      visible={visible}
      title={title || "Confirm"}
      ariaLabel={title || "Confirm"}
      onCancel={cancel}
      modalStyle={modalStyle || { width: '33.75rem' }}
      footerStyle={{ 'paddingTop': '8px', 'marginTop': '-8px', 'minHeight': '64px' }}
      header={""}
      icons={""}
      footer={
        <>
          <Button onClick={cancel} kind="secondary">Cancel</Button>
          <Button onClick={confirm} kind="negative">Confirm</Button>
        </>
      }
    >
      {children}
    </Modal>
  );
}

export const EditModal: FC<ModalProps> = ({ children, title, cancel, visible, modalStyle }) => {
  return (
    <Modal
      visible={visible}
      // title={title || "Add new"}
      ariaLabel={title || "Add new"}
      onCancel={cancel}
      modalStyle={modalStyle || { width: '33.75rem' }}
      header={""}
      icons={""}
      id="modal-user"
    >
      {children}
    </Modal>
  )
}
